import './Spinner.scss';

interface SpinnerProps {
  size?: number;
  className?: string;
}

export const Spinner = ({ size = 20, className = '' }: SpinnerProps) => {
  return (
    <span
      className={`spinner ${className}`}
      style={{ width: size, height: size, borderWidth: Math.max(2, size / 10) }}
      role="status"
      aria-label="Loading"
    />
  );
};
